<template>
    <div class="document-client">
        <title-screen title="18"></title-screen>
        <AnkenInfo :id="ankenId" @ankenInfoLoad="ankenInfoLoad"/>
        <el-row id="estimation-file" style="padding-bottom: 1em">
            <el-col :span="18">
                <div class="pulldown-nav">
                  こちらから閲覧する書類をご選択ください
                </div>
                <el-select @change="viewFile" placeholder="選択してください" v-model="selectedReport">
                    <el-option
                            :key="item.reportId"
                            :label="item.reportName"
                            :value="item.reportId"
                            v-for="item in listFileReport">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6" align="right" style="padding-top: 20px; white-space: nowrap" v-if="url != null">ご提供日: {{ publishedAt }}
            </el-col>
        </el-row>
        <div :style="{'height': heightLoading}">
            <div class="panel file-content center-content" v-if="url == null">
                <h1 v-if="!isLoadingFile">{{ message }}</h1>
                <img v-else src="@/assets/images/loading.gif" alt="loading">
            </div>
            <div v-else-if="isMobile || isIE">
                <pdfjs :src="url"></pdfjs>
            </div>
            <iframe :src="url" height="600px" title="PDF file" type="application/pdf" v-else width="100%"></iframe>
        </div>
    </div>
</template>

<script>
  import AnkenInfo from '../38_anken/AnkenInfo.vue'
  import ApiReport from '@/api/report/report.js'
  import TitleScreen from '@/components/common/TitleScreen'
  import { isMobile } from 'mobile-device-detect'
  import Pdfjs from '../../../../components/pdfjs/Pdfjs'
  import { isIE } from '@/common/useragent'
  import { REPORT_TYPE } from '@/common/constants'

  let moment = require('moment')

  export default {
    name: 'Estimation',
    data () {
      return {
        publishedAt: null,
        proposalPublishedAt: null,
        estimatePublishedAt: null,
        proposalUrl: null,
        proposalFilePath: null,
        estimationUrl: null,
        estimationFilePath: null,
        filePath: null,
        url: null,
        message: null,
        ankenId: 0,
        isAnkenInfoLoaded: false,
        scr: null,
        numPages: undefined,
        isMobile: isMobile,
        listFileReport: [],
        selectedReport: null,
        isLoadingFile: false
      }
    },
    components: {
      TitleScreen,
      AnkenInfo,
      Pdfjs
    },
    mounted () {
      this.ankenId = parseInt(this.$route.params.id)
      if (this.ankenId > 0) {
        this.loadReportData()
        this.scrollToBottom()
        this.message = 'ご報告書はまだ作成されていません。'
      }
    },
    methods: {
      loadReportData () {
        // クエリパラメータからreportTypeを取得
        const reportType = this.$route.query.type === 'qr' ? REPORT_TYPE.QR
                          : this.$route.query.type === 'report' ? REPORT_TYPE.REPORT : null
        ApiReport.getListFileClient(this.ankenId, reportType).then(response => {
          let responseData = response.data
          if (responseData) {
            this.listFileReport = responseData
            if (this.listFileReport.length > 0) {
              this.selectedReport = this.listFileReport[0].reportId
              this.viewFile(this.selectedReport)
            } else {
              this.selectedReport = null
              this.url = null
            }
          }
          // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          this.$router.back()
        })
      },
      ankenInfoLoad (val) {
        this.isAnkenInfoLoaded = val
      },
      async viewFile (val) {
        try {
          this.url = null
          this.isLoadingFile = true
          let res = await ApiReport.viewFileClient(this.ankenId, val)
          if (res && res.data) {
            this.url = res.data.fileSingedUrl
            this.publishedAt = moment.parseZone(res.data.uploadDateTime).format('YYYY年MM月DD日')
          }
        } catch (e) {
          this.$alert(e.message, 'エラー', {
            confirmButtonText: 'OK',
            type: 'error',
            center: true
          })
        } finally {
          this.isLoadingFile = false
        }
      },
      scrollToBottom () {
        this.$nextTick(() => {
          const ankenViews = document.getElementsByClassName('anken-info')
          if (ankenViews.length > 0) {
            const ankenView = ankenViews[0]
            if (ankenView) {
              var navHeight = 0
              if (window.innerWidth > 600 && window.innerHeight > 400) {
                const navViews = document.getElementsByClassName('gnav nav-height')
                if (navViews.length > 0) {
                  const navView = navViews[0]
                  if (navView) {
                    navHeight = navView.offsetHeight
                    if (!isIE() && this._$(navView).css('position') === 'static') navHeight += 60
                  }
                }
              }
              const scrollTop = ankenView.offsetTop + ankenView.offsetHeight - navHeight
              window.scroll(0, scrollTop)
            }
          }
        })
      }
    },
    computed: {
      isIE () {
        return isIE()
      },
      heightLoading () {
        return (this.isMobile || this.isIE) ? Math.round((297 / 210) * (window.innerWidth - 30)) + 'px' : '600px'
      }
    },
    watch: {
      isAnkenInfoLoaded: function () {
        this.scrollToBottom()
      },
      '$route.query.type': function () {
        // クエリパラメータが変更された時にデータを再読み込み
        this.loadReportData()
      }
    }
  }
</script>

<style scoped>
    .center-content {
        display: flex;
        align-items: center;
    }

    .pulldown-nav {
      font-size: 1rem;
    }

    .document-client ::v-deep .el-input__inner {
      border-color: red;
      border-width: 2px;
      font-weight: bold;
    }

    .document-client ::v-deep .el-select__caret {
      color: red;
      font-weight: bold;
    }

    .document-client ::v-deep .is-reverse {
      color: #409EFF;
    }

    @import '../7_document/document.css';
    @import "../../../../assets/css/custom.css";
</style>
